import REDUX_ACTION from '../../constants/action'

/**
 * Updates the `value` at the given `payload.path`.
 * @param {Object} action
 *        {Object} action.type
 *        {Object} action.payload
 *        {string} [action.payload.path]
 *        {string} [action.payload.paths]
 *        {string} [action.payload.updates]
 *        {string} [action.payload.key]
 *        {string} [action.payload.value]
 */
export default function updateReduxAction (action) {
  return {
    type: action.type,
    reduxType: REDUX_ACTION.UPDATE,
    payload: action.payload
  }
}
